import moment from "moment";

export const getDateTime = date =>
    moment(date).format("DD-MM-YYYY hh:mm A");

export const getDateTimeDef = date => {
    return moment(date).format("YYYY-MM-DD hh:mm A")
};

export const getDate = date =>
    moment(date).format("DD-MM-YYYY");

export const getDateF = date =>
    moment(date).format("DD/MM/YYYY");

export const getDateFRange = (date1, date2) => {
    if (date1 === date2)
        return moment(date1).format("DD/MM/YYYY");
    return moment(date1).format("DD/MM/YYYY") + " - " + moment(date2).format("DD/MM/YYYY")
};

export const getDateDef = date =>
    moment(date).format("YYYY-MM-DD");

export const getTime = date =>
    moment(date).format("hh:mm A");

export const getTimeN = date =>
    moment(date).format("hh:mm");

export const getTime24H = date =>
    moment(date).format("HH:mm:ss");

export const getTimeFull = date =>
    moment(date).format("hh:mm:ss A");

export const getDateTimeFull = date =>
    moment(date).format("DD-MM-YYYY hh:mm:ss");

export const getDateTimeFullDef = date =>
    moment(date).format("YYYY-MM-DD HH:mm:ss");


export const getDateTimeHH = date =>
    moment(date).format("YYYY-MM-DD HH:mm:ss");


export const dateToDateTime = date =>
    date.concat(" 00:00:00");


export const getLogin = date =>
    moment(date).fromNow();

export const getDateDisplay = date =>
    moment(date).format("DD / MM / YYYY");

export const getDateS = date => {
    return moment(date).format("DD / MM / YYYY")
};

export const getDateTimeS = date => {
    return moment(date).format("DD/MM/YYYY hh:mm A")
};
export const format12h = time => {
    if (!time) return "";

    const parsed = moment(time);
    if (parsed.isValid()) {
        return parsed.format("hh:mm A");
    }

    const parsedTime = moment(time, ["HH:mm", "H:mm", "hh:mm A"], true);
    if (parsedTime.isValid()) {
        return parsedTime.format("hh:mm A");
    }

    return "";
};

export const getDay = date => moment(date).format("dddd");

export const getDayTh = date => moment(date).format("ddd");

export const getTimeHH = date => {
    return moment(date).format("HH")
};

export const getMinute = date => {
    return moment(date).format("mm")
};

export const getDateSlash = date => {
    return moment(date).format("DD/MM/YYYY")
};
